import { render, staticRenderFns } from "./UploadTxt.vue?vue&type=template&id=41753c92&scoped=true&"
import script from "./UploadTxt.vue?vue&type=script&lang=js&"
export * from "./UploadTxt.vue?vue&type=script&lang=js&"
import style0 from "./UploadTxt.vue?vue&type=style&index=0&id=41753c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41753c92",
  null
  
)

export default component.exports